import React, { useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import ServicesList from "../components/UI/ServicesList";

import AOS from 'aos';
import "aos/dist/aos.css"

const ServiceListing = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <Helmet title="Services">
      <CommonSection title="All Services" />

      {/* ========== services section ============ */}
      <section id="services" data-aos="fade-up" className="services__section">
        <Container>
          <Row>
            <Col lg="12" className="mb-5 text-center">
              <h6 className="section__subtitle">See our</h6>
              <h2 className="section__title">Popular Services</h2>
            </Col>

            <ServicesList />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default ServiceListing;
